import React, { useEffect, useState } from "react";
import { RCCAlert, RCCButton, RCCGrid, RCCHookToast, RCCInput, RCCServicesApi, RCCTooltip } from "react-common-components";
import { useForm } from "react-hook-form";
import FiltersContainer from "src/components/FiltersContainer";
import PageTitle from "src/components/PageTitle";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import { IPatba001Hierarchy } from "./interface";
import ParametersHierarchyTree from "./parametersHierarchy";

const ParametersHierarchy: React.FC = () => {
	const { translate} = useTranslation();
	const { addToast} = RCCHookToast();
	const { setLoading } = useLoaderBackdrop();
	const controllerUrl = "Parameters/";

	const [showFilters, setShowFilters] = useState(false);  
	const [groups, setGroups] = useState<IPatba001Hierarchy[]>([]);
	const [filters, setFilters] = useState<{filter:string}>({ filter: ""});
	const {
		register,
		handleSubmit,
		reset
	}=useForm();

	const RequestGroups = async() =>
	{
		try {
			setLoading(true);
			const dataController = await RCCServicesApi.getRequest({
				method: `${controllerUrl}ListHierarchy`,
				urlParameters:{...filters}	
			});

			setGroups(dataController.data);
            
			setLoading(false);

		} catch (error) {
			standardErrorMessages(error, translate("Erro ao buscar hierarquia de parâmetros"), addToast);
			setLoading(false);
		}
	};
	
	useEffect(() => {
		RequestGroups();
	}, [filters]);

	return (	
		<RCCGrid
			container
			item
			direction="column"
		>
			{/* Header -> Results + Buttons */}
			<PageTitle
				title={translate("Hierarquia de parâmetros")}
				icon={{
					name: "hierarchy"
				}}
			>
				<RCCTooltip
					text={translate("Filtros")}
					color={showFilters || filters.filter ? "blue" : "grey"}
				>
					<RCCButton
						icon={{name: "filter", color: "#FFF", size: 16}}
						color={showFilters || showFilters || filters.filter ? "blue" : "grey"}
						layout="isRounded"
						size="md"
						onClick={() => setShowFilters((prevState) => !prevState)}
					/>
				</RCCTooltip>
			</PageTitle>

			{/* Filters */}
			<FiltersContainer
				onSubmitFilters={handleSubmit((data) => setFilters({filter:data.filter}))}
				resetFilters={
					() => reset({filter: ""})
				}
				showFilters={showFilters}
			>
				<RCCGrid
					item
					xs={12}
					sm={8}
					md={6}
					lg={6}
				>
					<RCCInput
						name="filter" 
						label={translate("Pesquisar")}
						register={register}
					/>
				</RCCGrid>
			</FiltersContainer>
            
			<RCCGrid container>
				
				{!groups || groups.length === 0 ? 
					<RCCAlert 
						title={translate("Atenção")}	
						description={translate("Não foram encontrados parâmetros para esta pesquisa")}
					/>
					:
					<ParametersHierarchyTree 
						groups={groups}
					/>}
			</RCCGrid>
			
		</RCCGrid>
	);
};

export default ParametersHierarchy;
